import { preact, JSX, $$ } from "../../Core/References";
import { DataControl, IDataControlProps } from "../DataControl/DataControl";

export interface IAutoCompleteGroupProps extends IDataControlProps
{
    NoRemove?: boolean;
    Mini?: boolean;
    OnRemoveItem?: Function;
    OnSelectItem?: Function;
}

export class ValueList<TValType extends KeyValue | string> extends DataControl<IAutoCompleteGroupProps, { data: TValType[] }>
{
    constructor(props: IAutoCompleteGroupProps)
    {
        super(props);

        this.setState({ data: [] });
    }

    public setValue(values: TValType[])
    {
        this.setState({ data: values as any|| [] });
    }

    public getValue(): TValType[]
    {
        return this.state.data as any;
    }

    public addValue(value: TValType)
    {
        if (value)
        {
            let data = this.state.data;
            let found = false;
            for (var i = 0; i < data.length; i++)
            {
                if (this._isKeyValue(value))
                {
                    if ((data[i] as KeyValue).Key == value.Key)
                    {
                        data[i] = value;  //update the entry in case the image or context has changed
                        found = true;
                        break;
                    }
                }
                else if(data[i] == value)
                {
                    data[i] = value;
                    found = true;
                    break;
                }
            }

            if (!found)
            {
                this.state.data.push(value);
            }

            this.forceUpdate();
        }
    }

    private _isKeyValue(value): value is KeyValue
    {
        return value.Key != null;
    }

    public override getValueRaw()
    {
        return this.getIds();
    }

    public focus()
    {
        let items = this.Container.getElementsByTagName("li");
        if (items.length > 0)
        {
            $$.focus(items[0]);
        }
    }

    public getIds(): string[]
    {
        return this.state.data.map((item, index) => ((item as any).Key || item));
    }

    private _handleListClick(event)
    {
        let li = this._getListItem(event.target);
        if ($$.containsCssClass(event.target, "deleteImage"))
        {
            this._removeItem(li);
            return;
        }

        this._selectItem(li);
    }

    private _selectItem(li: HTMLSpanElement): void
    {
        if (li && this.props.OnSelectItem)
        {
            this.props.OnSelectItem(li.getAttribute("data-key"));
        }
    }

    private _handleListKeyDown(event: KeyboardEvent)
    {
        let li = this._getListItem(event.target);

        if (event.key === "Enter")
        {
            this._selectItem(li);    
            event.stopPropagation();
            event.preventDefault();
        }
        else if(event.key === "Delete")
        {
            this._removeItem(this._getListItem(event.target));

            event.stopPropagation();
            event.preventDefault();
        }
    }

    private _removeItem(item: HTMLElement)
    {
        if (item)
        {
            let index = $(item).index();
            this.state.data.splice(index, 1);
            this.forceUpdate();

            if (this.props.OnRemoveItem)
            {
                this.props.OnRemoveItem(item.getAttribute("data-key"));
            }
        }
    }

    private _getListItem(target): HTMLSpanElement
    {
        return $$.getParent(target, "span", "valueItem");
        //return $(target).closest("li", this._lstOptions).get(0) as HTMLLIElement;
    }



    public render(): JSX.Element
    {
        return (
            <div className="autogroupOptions" ref={(ref) => this._registerContainer.bind(this)(ref)} >
                    <div className={this.props.Mini ? "autogroup mini" : "autogroup"}
                        onKeyDown={this._handleListKeyDown.bind(this)}
                        onClick={this._handleListClick.bind(this)}>
                        {
                            this.state.data.map((item, index) =>
                            {
                                return this._renderItem(item);
                            })
                        }
                    </div>
                </div>
            );
    }

    private _renderItem(item): JSX.Element
    {
        return (
            <span
                data-key={item.Key || item}
                tabIndex={0}
                class="valueItem">
                <span className="groupContent">
                    {!this.props.Mini && item.ImagePath && (<img src={item.ImagePath} />)}
                    <span style="display: inline-block; vertical-align: top; margin-left: 4px;">
                        <span className="itemName">{item.Value || item}</span>
                        {!this.props.Mini && item.Context && (<span><span className="subcontext">{item.Context}</span></span>)}
                    </span>
                    {
                        !this.props.NoRemove ? <span className="deleteImage" />: null
                    }
                    
                </span>
            </span>
        );
    }
}